import { render } from "./VehicleModificationInformation.vue?vue&type=template&id=00a88ba5&scoped=true&ts=true"
import script from "./VehicleModificationInformation.vue?vue&type=script&lang=ts"
export * from "./VehicleModificationInformation.vue?vue&type=script&lang=ts"

import "./VehicleModificationInformation.vue?vue&type=style&index=0&id=00a88ba5&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\TTI.AVE.Web\\Vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00a88ba5"]])

export default __exports__